<template>
  <div class="big">
    <el-dialog :title="`${!isAdd ? '添加' : '编辑'}多选题`"
               :visible.sync="dialog"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="add-checkbox-dia">
        <el-form :model="checkboxForm"
                 :rules="checkboxRules"
                 ref="checkboxFormRef"
                 label-width="60px">
          <el-form-item label="题目"
                        prop="title">
            <el-input v-model="checkboxForm.title"
                      placeholder="请输入"></el-input>
          </el-form-item>

          <div class="way">
            <el-form-item label="方式"
                          prop="answer_obj">
              <el-select v-model="checkboxForm.answer_obj"
                         placeholder="请选择方式">
                <el-option label="患者回答"
                           :value="1"></el-option>
                <el-option label="医生回答"
                           :value="2"></el-option>
                <el-option label="医生患者都可回答"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否必填"
                          prop="is_write"
                          label-width="80px"
                          class="checkbox-box">
              <el-radio-group v-model="checkboxForm.is_write">
                <el-radio :label="1">必填</el-radio>
                <el-radio :label="0">非必填</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="add-options">
            <el-link :underline="false"
                     @click="addOptions"><i class="el-icon-plus el-icon--right"></i> 添加选项</el-link>
          </div>

          <div v-if="optionArr.length"
               class="option-box">
            <div v-for="(item, index) in optionArr"
                 :key="item.id"
                 class="option-item">
              <el-input type="input"
                        placeholder="请输入内容"
                        v-model="item.value">
              </el-input>

              <i class="el-icon-delete"
                 style="color:#F56C6C;cursor: pointer;"
                 @click="delOption(item, index)"></i>
            </div>
          </div>
        </el-form>
      </div>
      <div style="text-align: center; padding: 10px 0">
        <el-button @click="closeShow(false)">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('checkboxFormRef')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    isAdd: {
      type: Number,
      require: true
    },
    content: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: true,
      checkboxForm: {
        title: '',
        answer_obj: '',
        is_write: 1
      },
      checkboxRules: {
        title: [
          { required: true, message: '请输入题目', trigger: 'blur' },
          { max: 100, message: '题目长度100字以内', trigger: 'blur' }
        ],
        answer_obj: [
          { required: true, message: '请选择方式', trigger: 'change' }
        ]
      },
      optionArr: [],
      optionNum: 0
    };
  },
  created() {
    if (this.isAdd) {
      this.checkboxForm = _.pick(this.content, [
        'title',
        'answer_obj',
        'is_write',
        '$index'
      ]);
      this.optionArr = this.content.content;
      this.optionNum = this.content.content.length;
    }
  },
  methods: {
    addOptions() {
      if (this.optionArr.length == 10) {
        this.$message.warning('只能添加10个选项');
        return;
      }
      this.optionArr.push({
        id: this.optionNum++,
        value: ''
      });
    },
    delOption(item, index) {
      this.optionArr.splice(index, 1);
    },
    closeShow(data) {
      this.$emit('closeShow', data);
    },
    //提交
    submitForm(formName) {
      if (!this.optionArr.length) {
        this.$message.error('请添加选项');
        return;
      }
      let isEmpty = this.optionArr.some((item) => {
        return item.value == '';
      });
      if (isEmpty) {
        this.$message.error('添加选项内容不能为空');
        return;
      }

      let isRepeat =
        _.uniqBy(this.optionArr, 'value').length == this.optionArr.length;
      if (!isRepeat) {
        this.$message.error('添加选项内容不能重复');
        return;
      }

      if (this.optionArr.length < 2) {
        this.$message.error('添加选项要2个以上');
        return;
      }

      // let isLength = this.optionArr.some((item) => {
      //   return item['value'].length > 30;
      // });

      // if (isLength) {
      //   this.$message.error('添加选项内容长度30字以内');
      //   return;
      // }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = Object.assign(this.checkboxForm, {
            content: this.optionArr,
            item_type: 2
          });
          this.closeShow(data);
        } else {
          return false;
        }
      });
    },
    resetForm() {}
  }
};
</script>
<style lang="scss" scoped>
.add-checkbox-dia {
  padding: 20px 20px 0 20px;
  box-sizing: border-box;

  .way {
    display: flex;
    height: 50px;
    .checkbox-box {
      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        .el-radio-group {
          display: flex;
        }
      }
    }
  }
  .add-options {
    margin-top: 20px;
    .el-link {
      font-size: 16px;
      color: #40aaff;
    }
    padding-bottom: 10px;
  }
  .option-box {
    max-height: 300px;
    padding-left: 60px;
    overflow: auto;
    .option-item {
      margin-bottom: 10px;
      .el-input {
        width: 240px;
        margin-right: 20px;
      }
    }
  }
}
</style>
